var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.avgStars)?_c('div',{staticClass:"stars-small"},_vm._l((5),function(item,i){return _c('RemixIconComponent',{key:item,class:{ 'stars-small--fill': i < _vm.roundedStars },attrs:{"category":"system","name":"star-fill"}})}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }